<app-bottom-sheet
  [title]="'voiceAssistant.title' | translate"
  [headerVariant]="embeddedArtifact() ? 'default' : 'assistant'"
  [closeAriaLabel]="'voiceAssistant.closeSheet' | translate"
  [isOpen]="sheetOpen()"
  [bodyScrollMode]="'contain'"
  (close)="closeSheet()">
  @if (embeddedArtifact(); as art) {
    <div
      class="va-hybrid-root d-flex flex-column min-h-0 flex-grow-1"
      [class.va-hybrid-root--form-expanded]="manualFormExpanded()">
      <div
        class="va-hybrid-chat flex-shrink-0 border-bottom border-light-subtle">
        <app-voice-assistant-panel
          [showTitle]="false"
          [hybridEducationalLayout]="true"
          [unifiedPopupLayout]="true"
          [sheetFixedChrome]="true"
          (openResourceSetup)="
            embeddedArtifact.set($event)
          "></app-voice-assistant-panel>
      </div>

      <div
        class="va-hybrid-manual-toggle flex-shrink-0 border-bottom px-2 py-2 bg-body-tertiary">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary w-100 text-start"
          (click)="toggleManualForm()"
          [attr.aria-expanded]="manualFormExpanded()"
          [attr.aria-controls]="'va-hybrid-knowledge-' + art"
          id="va-hybrid-manual-toggle">
          {{
            (manualFormExpanded()
              ? 'voiceAssistant.workflow.hideManualForm'
              : 'voiceAssistant.workflow.showManualForm'
            ) | translate
          }}
        </button>
      </div>

      <div
        class="va-hybrid-form d-flex flex-column min-h-0"
        [class.va-hybrid-form--collapsed]="!manualFormExpanded()"
        role="region"
        [attr.aria-label]="
          'voiceAssistant.workflow.manualFormRegion' | translate
        "
        [attr.id]="'va-hybrid-knowledge-' + art">
        <div
          class="va-hybrid-form-inner d-flex flex-column min-h-0 flex-grow-1">
          <app-knowledge-setup
            [embedMode]="true"
            [artifact]="art"
            (back)="clearEmbeddedResource()"></app-knowledge-setup>
        </div>
      </div>
    </div>
  } @else {
    <app-voice-assistant-panel
      [showTitle]="false"
      [hybridEducationalLayout]="!!embeddedArtifact()"
      [unifiedPopupLayout]="true"
      [sheetFixedChrome]="true"
      (openResourceSetup)="
        embeddedArtifact.set($event)
      "></app-voice-assistant-panel>
  }
</app-bottom-sheet>
